import React from "react";
import { useSelector } from "react-redux";
import { getNotifications } from "../../api/notifications/notifications";
import {
  TNotification,
  TNotifications,
} from "../../components/dashboardpages/notifications/notificationBlock.interface";
import webSocketService from "../../utils/websocketService";
import { REACT_APP_WEB_SOCKET_URL } from "../../utils/appdetails";
import { RootState } from "../../store/store";

const useNotifications = (
  filter: { isRead: boolean | string },
  refetch: boolean
) => {
  const [notifications, setNotifications] = React.useState<TNotifications | []>(
    []
  );
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const { user } = useSelector((state: RootState) => ({
    user: state.user.user,
  }));

  const fetchNotifications = async () => {
    try {
      setIsLoading(true);
      const response = await getNotifications(filter);
      setNotifications(response?.data?.data?.docs);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  React.useEffect(() => {
    fetchNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.isRead, refetch]);

  // set up socket connection
  React.useEffect(() => {
    // Listen for incoming notifications from WebSocket
    const handleNewNotification = (notification: TNotification) => {
      // Update the notifications state with the new notification
      setNotifications((prevNotifications) => [
        ...prevNotifications,
        notification,
      ]);
    };

    webSocketService.connect(`${REACT_APP_WEB_SOCKET_URL}/notification` || "");

    // Join the notification room
    webSocketService.joinNotificationRoom(user?._id || "");

    webSocketService.onNewNotification(handleNewNotification);

    // Clean up the WebSocket event listener on unmount
    return () => {
      webSocketService.disconnect();
    };
  }, []); // Empty dependency array for one-time setup

  return { notifications, isLoading };
};

export default useNotifications;
